// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
// bao migrate - module not found: import "modules/synoset-module";
import "./../../bindings/bao-number-box";
function ConfigurationItemHolidayEntitlementViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.Year = ko.observable();
    self.SelectedYear = ko.observable();
    self.HolidayTabCollection = ko.observableArray([]);
    self.HolidayTabPageIndex = ko.observable(0);
    self.HolidayTabPageIndex.subscribe(function () {
        self.RefreshHolidayDateGrid();
    });
    self.HolidayTabPageSize = ko.observable(10);
    self.HolidayTabTotalRows = ko.observable(0);
    self.HolidayTabSorting = ko.observableArray();
    self.HolidayTabSorting.subscribe(function () {
        self.RefreshHolidayTabGrid();
    });
    self.SelectedHolidayTabRow = ko.observable({});
    self.SelectedHolidayTabRow.subscribe(function () {
        self.ToggleHolidayTabToolbarButtons();
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemHolidayEntitlementNew":
                self.ShowHolidayTabDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "ConfigurationItemHolidayEntitlementEdit":
                if (self.SelectedHolidayTabRow() != null) {
                    self.ShowHolidayTabDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedHolidayTabRow().ConfigurationItem100HolidayEntitlementId);
                }
                break;
            case "ConfigurationItemHolidayEntitlementDelete":
                if (self.SelectedHolidayTabRow() != null) {
                    var selectedData = self.SelectedHolidayTabRow();
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageHolidayTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteHolidayTab(self.ConfigurationItem.ConfigurationItemId(), selectedData.ConfigurationItem100HolidayEntitlementId);
                        }
                    });
                }
                break;
        }
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageHolidayTab = Bao.Session.GetMessage("msgDeleteHolidayTab");
    var _deleteMessageTargetHourTab = Bao.Session.GetMessage("msgDeleteMessageTargetHourTab");
    self.TargetHourTabCollection = ko.observableArray([]);
    self.TargetHourPageIndex = ko.observable(0);
    self.TargetHourPageIndex.subscribe(function () {
        self.RefreshTargetHourGrid();
    });
    self.TargetHourTabPageSize = ko.observable(10);
    self.TargetHourTabTotalRows = ko.observable(0);
    self.TargetHourTabSorting = ko.observableArray();
    self.TargetHourTabSorting.subscribe(function () {
        self.RefreshTargetHourGrid();
    });
    self.SelectedTargetHourTabRow = ko.observable({});
    self.SelectedTargetHourTabRow.subscribe(function () {
        self.ToggleTargetHourTabToolbarButtons();
    });
    self.TargetHourTabToolbarButtons = ko.observableArray();
    self.TargetHourTabToolbarButtons.subscribe(function () { });
    self.toolbarTargetClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemHolidayEntitlementNew":
                self.ShowTargetHourTabDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "ConfigurationItemHolidayEntitlementEdit":
                if (self.SelectedTargetHourTabRow() != null) {
                    self.ShowTargetHourTabDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedTargetHourTabRow().ConfigurationItem100TargetHourId);
                }
                break;
            case "ConfigurationItemHolidayEntitlementDelete":
                if (self.SelectedTargetHourTabRow() != null) {
                    var selectedData = self.SelectedTargetHourTabRow();
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTargetHourTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteTargetHourTab(self.ConfigurationItem.ConfigurationItemId(), selectedData.ConfigurationItem100TargetHourId);
                        }
                    });
                }
                break;
        }
    };
    self.Value = ko.observable();
    self.ShowTargetHourTabDialog = function (configurationItemId, configurationItem100TargetHourId) {
        Bao.post("ConfigurationItemTab/ShowConfigurationItemTargetHourTabDialog", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: configurationItemId,
            configurationItem100HolidayEntitlementId: configurationItem100TargetHourId
        }), function (value) {
            self.Value(value);
            self.TargetDialog.ViewModel(ko.map.fromJS(value.Model));
            self.TargetDialog.ViewModel().Focus = function () { };
            self.TargetDialog.ViewModel().CompleteCheck = function () {
                var isComplete = true;
                if (Bao.Utils.String.IsNullOrWhitespace(self.TargetDialog.ViewModel().ValidFromDateJs())) {
                    isComplete = false;
                }
                if (Bao.Utils.String.IsNullOrWhitespace(self.TargetDialog.ViewModel().ValidToDateJs())) {
                    isComplete = false;
                }
                if (!isComplete) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
                return isComplete;
            };
            self.TargetDialog.Template(value.Message);
            self.TargetDialog.Open();
            self.TargetDialog.ViewModel().Focus();
            self.RefreshTargetHourGrid();
        });
    };
    self.AddTargetHourTab = function (model, ConfigurationItemId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemTargetHour", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            holidayEntitlementModel: ko.map.toJS(model),
            configurationItemId: ConfigurationItemId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshTargetHourGrid();
        });
    };
    self.DeleteTargetHourTab = function (ConfigurationItemId, ConfigurationItem100HolidayEntitlementId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemTargetHour", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: ConfigurationItemId,
            configurationItem100HolidayEntitlementId: ConfigurationItem100HolidayEntitlementId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshTargetHourGrid();
        });
    };
    self.SaveTargetHour = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemHolidayEntitlement", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.EditTargetHourTab = function (item) {
        self.ShowTargetHourTabDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItem100TargetHourId);
        self.RefreshTargetHourGrid();
    };
    self.ToggleTargetHourTabToolbarButtons = function () {
        ko.utils.arrayForEach(self.TargetHourTabToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "ConfigurationItemHolidayEntitlementDelete" || button.ActionKey() == "ConfigurationItemHolidayEntitlementEdit") {
                button.Enabled(self.SelectedTargetHourTabRow() != null);
            }
        });
    };
    self.TargetDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.TargetDialog.Width("400px");
    self.TargetDialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (self.TargetDialog.ViewModel().CompleteCheck()) {
                    self.AddTargetHourTab(self.TargetDialog.ViewModel(), self.ConfigurationItem.ConfigurationItemId());
                    self.TargetDialog.Close();
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.TargetDialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ToggleHolidayTabToolbarButtons = function () {
        ko.utils.arrayForEach(self.HolidayTabToolbarButtons(), function (button : any) {
            if (button.ActionKey() == "ConfigurationItemHolidayEntitlementDelete" || button.ActionKey() == "ConfigurationItemHolidayEntitlementEdit") {
                button.Enabled(self.SelectedHolidayTabRow() != null);
            }
        });
    };
    self.RefreshHolidayTabGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemHolidayEntitlementCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.HolidayTabPageIndex(),
            pageSize: self.HolidayTabPageSize(),
            sorting: self.HolidayTabSorting()
        }), function (searchResult) {
            self.SelectedHolidayTabRow(null);
            self.HolidayTabTotalRows(0);
            self.HolidayTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.HolidayTabCollection(searchResult.Models);
                self.HolidayTabTotalRows(searchResult.TotalRows);
                self.ToggleHolidayTabToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.RefreshTargetHourGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemTargetHourCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.TargetHourPageIndex(),
            pageSize: self.TargetHourTabPageSize(),
            sorting: self.TargetHourTabSorting()
        }), function (searchResult) {
            self.SelectedTargetHourTabRow(null);
            self.TargetHourTabTotalRows(0);
            self.TargetHourTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TargetHourTabCollection(searchResult.Models);
                self.TargetHourTabTotalRows(searchResult.TotalRows);
                self.ToggleHolidayTabToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.HolidayTabToolbarButtons = ko.observableArray();
    self.HolidayTabToolbarButtons.subscribe(function () {
        self.ToggleHolidayTabToolbarButtons();
    });
    self.AddHolidayTab = function (model, ConfigurationItemId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemHolidayEntitlement", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            holidayEntitlementModel: ko.map.toJS(model),
            configurationItemId: ConfigurationItemId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshHolidayTabGrid();
        });
    };
    self.DeleteHolidayTab = function (ConfigurationItemId, ConfigurationItem100HolidayEntitlementId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemHolidayEntitlement", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: ConfigurationItemId,
            configurationItem100HolidayEntitlementId: ConfigurationItem100HolidayEntitlementId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshHolidayTabGrid();
        });
    };
    self.Save = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemHolidayEntitlement", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.EditHolidayTab = function (item) {
        self.ShowHolidayTabDialog(self.ConfigurationItem.ConfigurationItemId(), item.ConfigurationItem100HolidayEntitlementId);
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("600px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                self.Dialog.ViewModel().CompleteCheck().then(function (result) {
                    if (result) {
                        self.AddHolidayTab(self.Dialog.ViewModel(), self.ConfigurationItem.ConfigurationItemId());
                        self.Dialog.Close();
                    }
                });
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowHolidayTabDialog = function (configurationItemId, configurationItem100HolidayEntitlementId) {
        Bao.post("ConfigurationItemTab/ShowConfigurationItemHolidayEntitlementTabDialog", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: configurationItemId,
            configurationItem100HolidayEntitlementId: configurationItem100HolidayEntitlementId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().YearCollection = ko.observableArray([]);
            Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), function (result) {
                var YearArray = [];
                for (var r in result) {
                    if (result[r] != null)
                        if (result[r].Key != "") {
                            YearArray.push(result[r].Key);
                        }
                }
                self.Dialog.ViewModel().YearCollection(YearArray);
                self.Dialog.ViewModel().Year(value.Model.Year);
            });
            self.Dialog.ViewModel().Focus = function () { };
            self.Dialog.ViewModel().CompleteCheck = function () {
                var def = $.Deferred();
                var isComplete = true;
                if (self.Dialog.ViewModel().Year() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().HolidayEntitlement() == null) {
                    isComplete = false;
                }
                if (isComplete) {
                    Bao.post("ConfigurationItemTab/IsHolidayEntitlementValid", JSON.stringify({
                        sessionTabId: parent.TabPage.SessionTabId,
                        configurationItem100HolidayEntitlementId: self.Dialog.ViewModel().ConfigurationItem100HolidayEntitlementId(),
                        year: self.Dialog.ViewModel().Year(),
                        ticketTypeId: self.Dialog.ViewModel().TicketTypeId(),
                        holidayEntitlement: self.Dialog.ViewModel().HolidayEntitlement()
                    })).then(function (value) {
                        if (value == false) {
                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgHolidayEntitlementYearExists"), "info");
                            def.resolve(false);
                        }
                        else {
                            def.resolve(true);
                        }
                    });
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                    def.resolve(false);
                }
                return def.promise();
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            self.Dialog.ViewModel().Focus();
        });
    };
    self.Refresh = function () {
        self.RefreshHolidayTabGrid();
        self.RefreshTargetHourGrid();
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.loaded = function () {
        return self.Refresh();
        self.RefreshHolidayTabGrid();
        self.RefreshTargetHourGrid();
    };
}
;
export default ConfigurationItemHolidayEntitlementViewModel;